if (!customElements.get('cart-bar')) {
  class CartBar extends HTMLElement {
    constructor() {
      super();
      this._onScroll = () => this._updateVisibility();
      this._onRebuyInit = () => {
        const rebuyButton = this.form?.querySelector('button.rebuy-button');
        if (rebuyButton) {
          this.atcButton = rebuyButton;
        }
      };
      this._onBarButton = () => this._clearLoadingState();
      this._onBarError = () => this._scrollToTop();
      this._onVariantChange = (event) => this._updateFromVariantChange(event.detail);
      this._onButtonClick = (e) => {
        e.preventDefault();

        if (this.cartBarBtn.hasAttribute('data-add-to-cart-bar')) {
          this._addToCart();
        } else if (this.cartBarBtn.hasAttribute('data-cart-bar-scroll')) {
          const optionsSections = this.container.querySelector('.product__page .form__wrapper');
          let top = 0;

          if (optionsSections) {
            const header = document.querySelector('.theme__header');
            const headerHeight = header?.offsetHeight ?? 0;
            top = window.pageYOffset + optionsSections.getBoundingClientRect().top - headerHeight - 5;
          }

          window.scrollTo({ top, left: 0, behavior: 'smooth' });
        }
      };
    }

    connectedCallback() {
      this.container = this.closest('[data-section-type="product"]');
      if (!this.container) return;

      this.buttonAdd = this.dataset.buttonAdd === 'true';
      this.form = this.container.querySelector('[data-form-wrapper]');
      this.formWrapper = this.querySelector('[data-form-wrapper]');
      this.priceWrapper = this.querySelector('[data-price-wrapper]');
      this.productPriceEl = this.querySelector('[data-product-price]');
      this.comparePriceEl = this.querySelector('[data-compare-price]');
      this.comparePriceText = this.querySelector('[data-compare-text]');
      this.cartBarBtn = this.querySelector('.product__submit__add');
      this.cartBarBtnLabel = this.cartBarBtn?.querySelector('span');
      this.atcButton = this.form?.querySelector('[data-add-to-cart]');
      this.siteFooter = document.querySelector('.site-footer-wrapper');
      this.headerElement = document.querySelector('[data-header-height]');
      this.offsetBottom = this.headerElement?.offsetHeight ?? 0;
      this.productJSON = this._getProductJSON();

      if (this.cartBarBtn) {
        this.cartBarBtn.addEventListener('click', this._onButtonClick);

        if (this.cartBarBtn.hasAttribute('data-add-to-cart-bar')) {
          document.addEventListener('product:bar:error', this._onBarError);
        }

        if (window.theme.cartDrawerEnabled) {
          document.addEventListener('product:bar:button', this._onBarButton);
        }
      }

      this.container.addEventListener('theme:variant:change', this._onVariantChange);
      document.addEventListener('rebuy.init', this._onRebuyInit);
      document.addEventListener('theme:scroll', this._onScroll);

      this._syncInitialState();
    }

    disconnectedCallback() {
      this.cartBarBtn?.removeEventListener('click', this._onButtonClick);
      this.container?.removeEventListener('theme:variant:change', this._onVariantChange);
      document.removeEventListener('rebuy.init', this._onRebuyInit);
      document.removeEventListener('theme:scroll', this._onScroll);
      document.removeEventListener('product:bar:error', this._onBarError);
      document.removeEventListener('product:bar:button', this._onBarButton);
    }

    _getProductJSON() {
      const productJson = this.container.querySelector('[data-product-json]');
      if (!productJson?.innerHTML) return null;

      try {
        return JSON.parse(productJson.innerHTML);
      } catch {
        return null;
      }
    }

    _formatMoney(cents) {
      if (cents === 0) {
        return window.theme.strings.free;
      }

      if (window.themeVendor?.themeCurrency) {
        return window.themeVendor.themeCurrency.formatMoney(cents, window.theme.moneyFormat);
      }

      return (cents / 100).toFixed(2);
    }

    _updateFromVariantChange({ variant, plan, productState }) {
      if (!variant || !productState) return;

      this.currentVariant = variant;
      this.currentPlan = plan;

      this._updatePrices(variant, plan, productState);

      if (this.buttonAdd) {
        this._updateButtonState(variant);
        this._updateFormWrapperState(variant);
      }
    }

    _updatePrices(variant, plan, productState) {
      if (!this.priceWrapper || !this.productPriceEl) return;

      let comparePrice = '';
      let price = '';

      if (productState.available) {
        comparePrice = variant.compare_at_price;
        price = variant.price;
      }

      if (productState.hasPlan && plan?.allocation) {
        price = plan.allocation.price;
      }

      if (productState.planSale && plan?.allocation) {
        comparePrice = plan.allocation.compare_at_price;
        price = plan.allocation.price;
      }

      const onSale = productState.onSale || productState.planSale;

      if (this.comparePriceEl) {
        if (onSale) {
          this.comparePriceEl.classList.remove('hide');
          this.comparePriceText?.classList.remove('hide');
          this.productPriceEl.classList.add('product__price--sale');
          this.comparePriceEl.innerHTML = this._formatMoney(comparePrice);
        } else {
          this.comparePriceEl.classList.add('hide');
          this.comparePriceText?.classList.add('hide');
          this.productPriceEl.classList.remove('product__price--sale');
        }
      }

      this.productPriceEl.innerHTML = this._formatMoney(price);
      this.priceWrapper.classList.remove('hide');
    }

    _updateButtonState(variant) {
      if (!this.cartBarBtn || !this.cartBarBtnLabel) return;

      if (!variant) {
        this.cartBarBtnLabel.innerHTML = window.theme.strings.unavailable;
        this.cartBarBtn.disabled = true;
        return;
      }

      if (!variant.available) {
        this.cartBarBtnLabel.innerHTML = window.theme.strings.soldOut;
        this.cartBarBtn.disabled = true;
        return;
      }

      let addText = window.theme.strings.addToCart;
      const option = this.container.querySelector(
        `.product__form__select--info option[value="${variant.id}"]`
      );

      if (option?.dataset.showPreorder === 'true') {
        addText = window.theme.strings.preOrder;
      }

      if (this.productJSON?.tags?.includes('_preorder')) {
        addText = window.theme.strings.preOrder;
      }

      if (this.container.classList.contains('template-preorder')) {
        addText = 'PRE-ORDER';
      }

      this.cartBarBtnLabel.innerHTML = addText;

      if (!this.cartBarBtn.classList.contains('is-loading')) {
        this.cartBarBtn.disabled = false;
      }
    }

    _updateFormWrapperState(variant) {
      if (!this.formWrapper) return;

      if (variant) {
        if (variant.available) {
          this.formWrapper.classList.remove('variant--soldout', 'variant--unavailabe');
        } else {
          this.formWrapper.classList.add('variant--soldout');
          this.formWrapper.classList.remove('variant--unavailabe');
        }
      } else {
        this.formWrapper.classList.add('variant--unavailabe');
        this.formWrapper.classList.remove('variant--soldout');
      }
    }

    _getSelectedPlan(variant) {
      const productForm = this.container.querySelector('[data-product-form]');
      const form = productForm?.tagName === 'FORM' ? productForm : productForm?.querySelector('form');
      if (!form || !variant) return null;

      const planId = new FormData(form).get('selling_plan');
      if (!planId) return null;

      const allocation = variant.selling_plan_allocations?.find(
        (item) => item.selling_plan_id.toString() === planId.toString()
      );
      if (!allocation) return null;

      const group = this.productJSON?.selling_plan_groups?.find(
        (item) => item.id.toString() === allocation.selling_plan_group_id.toString()
      );
      const detail = group?.selling_plans?.find(
        (item) => item.id.toString() === planId.toString()
      );

      if (!group || !detail) return null;

      return { allocation, group, detail };
    }

    _setProductState(variant, plan) {
      const productState = {
        available: true,
        soldOut: false,
        onSale: false,
        hasPlan: false,
        planSale: false,
      };

      if (!variant || (variant.requires_selling_plan && !plan)) {
        productState.available = false;
        return productState;
      }

      if (!variant.available) {
        productState.soldOut = true;
      }

      if (variant.compare_at_price > variant.price) {
        productState.onSale = true;
      }

      if (plan && this.container.querySelector('[data-subscription-watch-price]')) {
        productState.hasPlan = true;

        if (variant.price > plan.allocation.price) {
          productState.planSale = true;
        }
      }

      return productState;
    }

    _syncInitialState() {
      if (!this.productJSON) return;

      const variantId = this._getVariantId();
      if (!variantId) return;

      const variant = this.productJSON.variants.find((v) => String(v.id) === String(variantId));
      if (!variant) return;

      const plan = this._getSelectedPlan(variant);
      const productState = this._setProductState(variant, plan);
      this._updateFromVariantChange({ variant, plan, productState });
    }

    _getProductForm() {
      const productFormEl = this.container.querySelector('[data-product-form]');
      if (!productFormEl) return null;

      return productFormEl.tagName === 'FORM' ? productFormEl : productFormEl.querySelector('form');
    }

    _getVariantId() {
      if (this.currentVariant?.id) {
        return this.currentVariant.id;
      }

      const form = this._getProductForm();
      const variantInput =
        form?.querySelector('[name="id"]') ||
        this.container.querySelector('[data-product-select]') ||
        this.container.querySelector('[name="id"]');
      const variantId = variantInput?.value;

      return variantId ? Number(variantId) : null;
    }

    _buildAddToCartPayload() {
      const form = this._getProductForm();
      const variantId = this._getVariantId();

      if (!form || !variantId) return null;

      const idInput = form.querySelector('[name="id"]');
      if (idInput) {
        idInput.value = variantId;
      }

      return new URLSearchParams(new FormData(form)).toString();
    }

    _addToCart() {
      if (!this.currentVariant?.available || this.cartBarBtn?.disabled) return;

      const payload = this._buildAddToCartPayload();
      if (!payload || !window.cart?.addToCart) return;

      window.cart.addToCart(payload, null, this.cartBarBtn);
    }

    _clearLoadingState() {
      if (this.cartBarBtn?.classList.contains('is-loading')) {
        this.cartBarBtn.classList.remove('is-loading');
        this.cartBarBtn.removeAttribute('disabled');
      }
    }

    _updateVisibility() {
      if (!this.form || !this.atcButton) return;

      const lastAddToCartButton = this.atcButton.getBoundingClientRect();
      const checkPosition = lastAddToCartButton.bottom <= this.offsetBottom;

      this.classList.toggle('is-visible', checkPosition);

      if (this.siteFooter) {
        this.siteFooter.classList.toggle('site-footer--push', checkPosition);
        this.siteFooter.style.marginBottom = this.siteFooter.classList.contains('site-footer--push')
          ? `${this.offsetHeight}px`
          : '0';
      }
    }

    _scrollToTop() {
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const isDesktop = windowWidth >= window.theme.sizes.small;
      const scrollTarget = isDesktop ? this.container : this.form;

      if (!scrollTarget) return;

      window.scrollTo({
        top: scrollTarget.getBoundingClientRect().top + window.scrollY,
        left: 0,
        behavior: 'smooth',
      });
    }
  }

  customElements.define('cart-bar', CartBar);
}
